/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const SculpturesIcon: React.SFC = () => {
    return (
        <svg width="46" height="46" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
            <title>Icon / sculptures</title>
            <g stroke="#FCA61B" fill="none" fillRule="evenodd">
                <path d="M9.5 40.5h26v-3h-26v3zM22.5 37L17 31.5l5.5-5.5 5.5 5.5zM22.5 15L17 9.5 22.5 4 28 9.5zM28 20.5c0 3.038-2.462 5.5-5.5 5.5S17 23.538 17 20.5c0-3.037 2.462-5.5 5.5-5.5s5.5 2.463 5.5 5.5z" />
            </g>
        </svg>
    )
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/AssetsIcons/Sculptures.tsx